import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoles } from '../store/roleSlice';

const Roles = () => {
  const dispatch = useDispatch();
  const { list, loading, error } = useSelector((state) => state.roles);

  useEffect(() => {
    dispatch(fetchRoles());
  }, [dispatch]);

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h2 style={{ color: '#1f2937' }}>Role Master</h2>
          <p style={{ color: '#6b7280' }}>View and manage system roles and permissions.</p>
        </div>
        <button className="btn btn-primary" style={{ padding: '0.6rem 1.25rem', borderRadius: '50px' }}>
          + Create Role
        </button>
      </div>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#e0e7ff', color: '#4f46e5' }}>☖</div>
          <div>
            <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#111827' }}>{list.length}</div>
            <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>Total Roles</div>
          </div>
        </div>
      </div>

      {error && <p style={{ color: 'var(--danger)' }}>Error loading roles.</p>}
      
      {loading && list.length === 0 ? <p style={{ color: '#6b7280' }}>Loading roles...</p> : (
        <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
          <table>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th style={{ color: '#374151' }}>Role Name</th>
                <th style={{ color: '#374151' }}>System Slug</th>
                <th style={{ color: '#374151' }}>Description</th>
                <th style={{ color: '#374151', textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.map(role => (
                <tr key={role.id}>
                  <td>
                    <div style={{ fontWeight: '600', color: '#4f46e5' }}>{role.name}</div>
                  </td>
                  <td>
                    <span style={{ 
                      background: '#f3f4f6', 
                      color: '#4b5563',
                      padding: '4px 8px', 
                      borderRadius: '4px',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      letterSpacing: '0.05em'
                    }}>
                      {role.name.toUpperCase()}
                    </span>
                  </td>
                  <td style={{ color: '#6b7280' }}>
                    {role.description || 'System standard role'}
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="btn" style={{ background: 'transparent', color: '#9ca3af', padding: '0.4rem' }}>✎</button>
                    <button className="btn" style={{ background: 'transparent', color: '#ef4444', padding: '0.4rem' }}>🗑</button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>No roles found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Roles;
